export const types = {
    CONNECT: 'CONNECT',
    DOWNLOADFILES: 'DOWNLOAD-FILES',
    DOWNLOADFOLDERS: 'DOWNLOAD-FOLDERS',
    UPLOADFOLDERS: 'UPLOAD-FOLDERS',
    UPLOADFILES: 'UPLOAD-FILES',
    DELETEFOLDERS: 'DELETE-FOLDERS',
    DELETEFILES: 'DELETE-FILES',
    MOVEFOLDERS: 'MOVE-FOLDERS',
    MOVEFILES: 'MOVE-FILES',
    RENAMEFOLDERS: 'RENAME-FOLDERS',
    RENAMEFILES: 'RENAME-FILES',
    CREATEFOLDER: 'CREATE-FOLDER',
}